import { view, hdrm } from '@yola/ws-sdk';
import { SubmitActionsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import { DESKTOP_BREAKPOINT } from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import linkTypes from '../../../common/components/link-field/constants/link-types';
import fieldNames from '../../../common/components/link-field/constants/field-names';
import mediaTypeIds from '../constants/media-type-ids';
import mediaContainerBuilder from './media-container-builder';
import dispatchPageBinding from './dispatch-page-binding';

const createSubmitActionsImageHandler =
  ({ mediaContainerElement, breakpoint = DESKTOP_BREAKPOINT }) =>
  (flowData, context) => {
    const targetElementId = view.accessors.getLiveElementId(mediaContainerElement);
    const targetStaticElement = view.accessors.getStaticElement(targetElementId);
    const newMediaContainerElement = targetStaticElement.cloneNode(true);

    const fieldsValues = {
      ...context.getFieldsValues(),
      ...(flowData?.modifiedFieldsValues || {}),
    };

    if (fieldsValues[fieldNames.LINK_TYPE] === linkTypes.BINDING) {
      dispatchPageBinding(fieldsValues);
    }

    mediaContainerBuilder.replaceContentFromFieldsValues(
      newMediaContainerElement,
      mediaTypeIds.IMAGE,
      fieldsValues,
      breakpoint
    );

    return SubmitActionsGenerationContract.create([
      view.actions.replaceElement(newMediaContainerElement, targetElementId, {
        strategy: hdrm.constants.updateStrategies.UPDATE_BOTH,
      }),
    ]);
  };

export default createSubmitActionsImageHandler;
